import { render, staticRenderFns } from "./Breadcrubs.vue?vue&type=template&id=e98933d8&"
import script from "./Breadcrubs.vue?vue&type=script&lang=js&"
export * from "./Breadcrubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports